/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Utils } from 'vmf';
import { Ce } from './Ce';

const { GlobalVar } = Utils;

class VerticalGrouping extends Ce {
    constructor() {
        super();
        this.baseUrl += '/verticalGrouping';
    }

    findVerticalGroupingList({
        verticalGroupingName,
        verticalGroupingSn,
        certCatId,
        certExamType,
        schoolOrgId,
        verticalGroupingStatus,
        verticalGroupingStatusNE,
        theoryExamTimeBeginEnd,
        practiceExamTimeBeginEnd,
        insertTime,
        certExamId,
        classExaminationType,
        certExamExamId,
        isRelationExam,
        examName,
        examStatus,
        idNE,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        let theoryExamTimeBegin = null;
        let theoryExamTimeEnd = null;
        if (theoryExamTimeBeginEnd != null && theoryExamTimeBeginEnd.length === 2) {
            [theoryExamTimeBegin, theoryExamTimeEnd] = theoryExamTimeBeginEnd;
        }
        let practiceExamTimeBegin = null;
        let practiceExamTimeEnd = null;
        if (practiceExamTimeBeginEnd != null && practiceExamTimeBeginEnd.length === 2) {
            [practiceExamTimeBegin, practiceExamTimeEnd] = practiceExamTimeBeginEnd;
        }
        let insertTimeBegin = null;
        let insertTimeEnd = null;
        if (insertTime != null && insertTime.length === 2) {
            [insertTimeBegin, insertTimeEnd] = insertTime;
        }
        return super.get('/findVerticalGroupingList', {
            verticalGroupingName,
            verticalGroupingSn,
            certCatId,
            certExamType,
            schoolOrgId,
            verticalGroupingStatus,
            verticalGroupingStatusNE,
            theoryExamTimeBegin,
            theoryExamTimeEnd,
            practiceExamTimeBegin,
            practiceExamTimeEnd,
            insertTimeBegin,
            insertTimeEnd,
            certExamId,
            classExaminationType,
            certExamExamId,
            isRelationExam,
            examName,
            examStatus,
            idNE,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }

    findVerticalGroupingListWithStat({
        verticalGroupingName,
        verticalGroupingSn,
        certCatId,
        certExamType,
        schoolOrgId,
        verticalGroupingStatus,
        theoryExamTimeBeginEnd,
        practiceExamTimeBeginEnd,
        insertTime,
        certExamId,
        classExaminationType,
        examName,
        examStatus,
        notRelSubsidyGrouping,
        verticalGroupingStatusType,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        let theoryExamTimeBegin = null;
        let theoryExamTimeEnd = null;
        if (theoryExamTimeBeginEnd != null && theoryExamTimeBeginEnd.length === 2) {
            [theoryExamTimeBegin, theoryExamTimeEnd] = theoryExamTimeBeginEnd;
        }
        let practiceExamTimeBegin = null;
        let practiceExamTimeEnd = null;
        if (practiceExamTimeBeginEnd != null && practiceExamTimeBeginEnd.length === 2) {
            [practiceExamTimeBegin, practiceExamTimeEnd] = practiceExamTimeBeginEnd;
        }
        let insertTimeBegin = null;
        let insertTimeEnd = null;
        if (insertTime != null && insertTime.length === 2) {
            [insertTimeBegin, insertTimeEnd] = insertTime;
        }
        return super.get('/findVerticalGroupingListWithStat', {
            verticalGroupingName,
            verticalGroupingSn,
            certCatId,
            certExamType,
            schoolOrgId,
            verticalGroupingStatus,
            theoryExamTimeBegin,
            theoryExamTimeEnd,
            practiceExamTimeBegin,
            practiceExamTimeEnd,
            insertTimeBegin,
            insertTimeEnd,
            certExamId,
            classExaminationType,
            examName,
            examStatus,
            notRelSubsidyGrouping,
            verticalGroupingStatusType,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id } = {}) {
        return super.get('/getDetail', { id }).then(json => {
            const { groupQrCode } = json.data.data.verticalGrouping;
            if (!groupQrCode) {
                json.data.data.verticalGrouping.groupQrCode = [];
            } else {
                json.data.data.verticalGrouping.groupQrCode = groupQrCode.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({
        id,
        verticalGroupingName,
        verticalGroupingSn,
        certExamId,
        schoolOrgId,
        headmasterId,
        verticalGroupingDesc,
        groupQrCode,
        examSite,
        trainingSite,
        verticalGroupingExamType,
        trainingPlanProgramId,
        trainingPlanProgramTime,
        theoryExamTimeBegin,
        theoryExamTimeEnd,
        practiceExamTimeBegin,
        practiceExamTimeEnd,
        trainTimeBegin,
        trainTimeEnd,
        coachTimeBegin,
        coachTimeEnd,
        remarks,
        isDownAdmitCard,
        isRequiredSurvey,
    } = {}) {
        const groupQrCodeStr = groupQrCode
            ? groupQrCode
                  .reduce((prev, curr) => {
                      prev.push(curr.name);
                      return prev;
                  }, [])
                  .join(',')
            : '';
        return super.post('/save', {
            id,
            verticalGroupingName,
            verticalGroupingSn,
            certExamId,
            schoolOrgId,
            headmasterId,
            verticalGroupingDesc,
            groupQrCode: groupQrCodeStr,
            examSite,
            trainingSite,
            verticalGroupingExamType,
            trainingPlanProgramId,
            trainingPlanProgramTime,
            theoryExamTimeBegin,
            theoryExamTimeEnd,
            practiceExamTimeBegin,
            practiceExamTimeEnd,
            trainTimeBegin,
            trainTimeEnd,
            coachTimeBegin,
            coachTimeEnd,
            remarks,
            isDownAdmitCard,
            isRequiredSurvey,
        });
    }

    effective({ ids, isCheckTime } = {}) {
        return super.post('/effective', {
            ids,
            isCheckTime,
        });
    }

    remove({ verticalGroupingId, ids } = {}) {
        return super.post('/remove', {
            verticalGroupingId,
            ids,
        });
    }

    synchronizeSuccess({ id } = {}) {
        return super.post('/synchronizeSuccess', {
            id,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    saveSeatNumber({ verticalGroupingId, certExamApplyId, seatNumber }) {
        return super.post('/saveSeatNumber', {
            verticalGroupingId,
            certExamApplyId,
            seatNumber,
        });
    }

    saveReviewInfo({ verticalGroupingId, reviewEffectTime, reviewExpireTime, reviewFirstClaim, reviewReviewTime }) {
        return super.post('/saveReviewInfo', {
            verticalGroupingId,
            reviewEffectTime,
            reviewExpireTime,
            reviewFirstClaim,
            reviewReviewTime,
        });
    }

    updateFillFormTime({ verticalGroupingId, fillFormTime }) {
        return super.post(
            '/updateFillFormTime',
            {
                verticalGroupingId,
                fillFormTime,
            },
            {
                isHandleError: true,
                timeout: 0,
            },
        );
    }

    initVerticalGroupingSeatNumber({ verticalGroupingId }) {
        return super.post('/initVerticalGroupingSeatNumber', { verticalGroupingId });
    }

    editScore({ verticalGroupingApplyId, examResult2, overallRatingResult }) {
        return super.post('/editScore', { verticalGroupingApplyId, examResult2, overallRatingResult });
    }

    confirmScore({ verticalGroupingId, verticalGroupingApplyId }) {
        return super.post('/confirmScore', { verticalGroupingId, verticalGroupingApplyId });
    }

    synchronizeApplyMaterialsScan({
        verticalGroupingId,
        idCardNo,
        front,
        firstClaim,
        effectTime,
        expireTime,
        reviewTime,
    }) {
        return super.post(
            '/synchronizeApplyMaterialsScan',
            {
                verticalGroupingId,
                idCardNo,
                front,
                firstClaim,
                effectTime,
                expireTime,
                reviewTime,
            },
            {
                isHandleError: true,
                timeout: 0,
            },
        );
    }

    certificateMake({ id }) {
        return super.post('/certificateMake', { id });
    }

    setVerticalGroupingFullLearn({ verticalGroupingId }) {
        return super.post(
            '/setVerticalGroupingFullLearn',
            { verticalGroupingId },
            {
                timeout: 0,
                isLoading: true,
            },
        );
    }

    createTrainingCertificate({ verticalGroupingId, certTime, ids }) {
        return super.post(
            '/createTrainingCertificate',
            {
                verticalGroupingId,
                certTime,
                ids,
            },
            {
                isHandleError: true,
                timeout: 0,
            },
        );
    }

    createSurvey({ verticalGroupingId, evaluateTemplateId }) {
        return super.post(
            '/createSurvey',
            { verticalGroupingId, evaluateTemplateId },
            {
                timeout: 0,
                isLoading: true,
            },
        );
    }
}

export default new VerticalGrouping();
export { VerticalGrouping };
